import { QuoteCard } from './QuoteCard'
import { Loading } from './Loading'
import type { Quote } from '../types'

interface QuoteListProps {
  quotes: Quote[]
  isLoading: boolean
  error: Error | null
  isFetchingNextPage?: boolean
}

export const QuoteList = ({ quotes, isLoading, error, isFetchingNextPage }: QuoteListProps) => {
  if (isLoading) {
    return <Loading />
  }

  if (error) {
    return (
      <div className="error-message">
        Fehler beim Laden der Zitate: {error.message}
      </div>
    )
  }

  if (!quotes || quotes.length === 0) {
    return (
      <div className="empty-state">
        <h3>Keine Zitate vorhanden</h3>
        <p>Erstelle dein erstes Zitat, um loszulegen.</p>
      </div>
    )
  }

  return (
    <>
      <div className="quote-grid">
        {quotes.map((quote) => (
          <QuoteCard key={quote.id} quote={quote} />
        ))}
      </div>
      {isFetchingNextPage && <Loading />}
    </>
  )
}
